import type { PreviewFormShimmerTheme } from '../types';

export const getPreviewFormShimmerStyles = (_: unknown, { palette = {} }: PreviewFormShimmerTheme) => ({
  container: {
    width: '100%',
    maxWidth: 1080,
    backgroundColor: palette.white,
    borderRadius: 4,
    boxShadow: '0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.13), 0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.1)',
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px',
    borderBottom: `1px solid ${palette.neutralLight}`,
  },

  title: {
    fontSize: 18,
    lineHight: '24px',
    fontWeight: 600,
  },

  button: {},

  summary: {
    padding: '16px 24px',
  },

  summaryItem: {
    display: 'flex',
    gap: '8px',
    padding: '10px 8px',
    minHeight: 40,
  },

  itemTitle: {
    width: 140,
    flexShrink: 0,
  },

  itemDetail: {
    flex: 1,
    maxWidth: 'calc(100% - 156px)',
  },
});
